import { arrayWrap } from "./array-utils";

export function getChangesetErrorsForProperty(changeset: any, property: string): string[] | undefined {
  const errors = changeset.error?.[property]?.validation;
  if (errors === undefined) {
    return undefined;
  }
  return arrayWrap(errors);
}
